<template>
  <div>
    <!--<form id="form1">-->
      <!--<div class='row h-row-inputBox h-tableHeight130'>-->
        <!--<div class='col-sm-6 h-col-inputBox'>-->
          <!--<div class='h-inputLit'>{{$t('TS.starttime')}}:</div>-->
          <!--<ejs-datepicker format='yyyy-MM-dd' v-model='startdate' name="startDateTime" :allowEdit="allowEdit" :locale="locale" :showClearButton="showClearButton"></ejs-datepicker>-->
        <!--</div>-->
        <!--<div class='col-sm-6 h-col-inputBox'>-->
          <!--<div class='h-inputLit'>{{$t('TS.endtime')}}:</div>-->
          <!--<ejs-datepicker format='yyyy-MM-dd' v-model='enddate' name="endDateTime" :allowEdit="allowEdit" :locale="locale" :showClearButton="showClearButton"></ejs-datepicker>-->
        <!--</div>-->
      <!--</div>-->
    <!--</form>-->
    <div class="col-sm-6">
      <div class='h-inputLit'>{{$t('TS.starttime')}}:</div>
      <ejs-datepicker format='yyyy-MM-dd' v-model='startdate' name="startDateTime" :allowEdit="allowEdit" :locale="locale" :showClearButton="showClearButton"></ejs-datepicker>
      <div class='div-space'></div>
      <div class='h-inputLit'>{{$t('TS.endtime')}}:</div>
      <ejs-datepicker format='yyyy-MM-dd' v-model='enddate' name="endDateTime" :allowEdit="allowEdit" :locale="locale" :showClearButton="showClearButton"></ejs-datepicker>
    </div>
    <div class="col-sm-6">
      <div class="h-title">{{$t('SubscriberIms.organization')}}</div>
      <div class="tree-box h-security-role-rightTree">
        <tree
          :setting="resourceAuthSetting"
          :nodes="resourceAuthNodes"
         />
      </div>
    </div>
  </div>
</template>

<script>
  import tree from 'vue-giant-tree'

export default {
  name: 'QueryCondition',
  components: {
    tree
  },
  data() {
    return {
      roleId: '',
      resourceAuthTreeObj: '',
      resourceAuthNodes: [],
      resourceAuthSetting: {
        data: {
          key: {
            name: 'name'
          },
          simpleData: {
            enable: true,
            idKey: 'id',
            pIdKey: 'pid',
            rootPId: 0
          }
        },
        check: {
          chkboxType: { 'Y': 'ps', 'N':'ps' },
          chkStyle: 'checkbox',
          enable: true
        }
      },
      resourceIdChecked: []
    };
  },
  methods: {
    initTreeData() {
      this.findAuthData()
    },
    findAuthData() {
      // const testResult = [{"id":0,"text":"Organization","iconCls":"tree-file","code":null,"vpnNodeString":"Organization","children":[{"id":1,"text":"test","iconCls":"tree-file","code":"test","vpnNodeString":"test","children":[{"id":2,"text":"test1","iconCls":"tree-file","code":"test1","vpnNodeString":"test1","children":[{"id":3,"text":"test2","iconCls":"tree-file","code":"test2","vpnNodeString":"test2","children":[{"id":5,"text":"test3","iconCls":"tree-file","code":"test3","vpnNodeString":"test3","children":null,"checked":false,"name":"test3","id_show":"2193_7_5","systemId":"2193_7_5"}],"checked":false,"name":"test2","id_show":"2193_7_3","systemId":"2193_7_3"}],"checked":false,"name":"test1","id_show":"2193_7_2","systemId":"2193_7_2"},{"id":4,"text":"A","iconCls":"tree-file","code":"A","vpnNodeString":"A","children":null,"checked":false,"name":"A","id_show":"2193_7_4","systemId":"2193_7_4"}],"checked":false,"name":"test","id_show":"2193_7_1","systemId":"2193_7_1"}],"checked":false,"name":"Organization","id_show":"2193_7_0","systemId":"2193"}];
      const testResult = [{"id":0,"name":"组织架构","code":"组织架构","pid":0},
        {"id":1,"name":"1","code":"1","pid":0},
        {"id":2,"name":"12","code":"12","pid":1},
        {"id":3,"name":"12","code":"13","pid":1},
        {"id":4,"name":"24","code":"24","pid":2},
        {"id":5,"name":"5","code":"5","pid":0},
        {"id":6,"name":"56","code":"56","pid":5},
        {"id":7,"name":"67","code":"67","pid":6},
        {"id":8,"name":"78","code":"78","pid":7}
      ];
      let test = [];
      test.push({"id":0,"name":"组织架构",code:"组织架构","pid":0});
      for(var i=0;i<100;i++) {
        const temp = {"id":++i,"name":i+"","name":i+"","pid":0};
        test.push(temp);
      }
      // for(var i=0;i<500;i++) {
      //   const temp = {"id":100+i,"name":100+i+"","name":100+i+"","pid":0};
      // }
      this.resourceAuthNodes = test;
      // this.resourceAuthNodes = testResult
    },
  }
};
</script>

<style scoped>

</style>
